<div class="switcher">
  <div class="row">
    <div class="toggle-button-cover">
      <div class="button-cover">
        <div class="button r" id="button-1" 
        :tabindex="0" @keypress.enter="onClickKeypress" >
          <label :for="state.id"></label>
          <input type="checkbox" class="checkbox" v-model="privateIsChecked" checked :id="state.id">
          <div class="knobs"></div>
          <div class="layer"></div>
        </div>
      </div>
    </div>
  </div>
</div>